
import { PDFDocument } from 'pdf-lib';

import fontkit from '@pdf-lib/fontkit';

import { capitalize } from '../utils.js';

import { fetchUint8Array, drawText, savePDF } from './utils.js';

import { letterBackground, letterContent } from '../stores/activity-3.js';

import openSansRegular from '../fonts/open-sans-regular.ttf';

import indieFlowerRegular from '../fonts/indie-flower-regular.ttf';

import cutiveMonoRegular from '../fonts/cutive-mono-regular.ttf';

import kalamRegular from '../fonts/kalam-regular.ttf';

import templates from './activity-3-*.pdf';

const letterFonts = {
  
  'table': indieFlowerRegular,
  
  'typewriter': cutiveMonoRegular,

  'nightstand': kalamRegular

};

export async function exportPDF( firstName, lastName ) {

  const sansFontBytes = await fetchUint8Array( openSansRegular );

  const letterFontBytes = await fetchUint8Array( letterFonts[ letterBackground.value ] );
  
  const templateBytes = await fetchUint8Array( templates[ letterBackground.value ] );
  
  const doc = await PDFDocument.load( templateBytes );
  
  doc.registerFontkit( fontkit );

  const sansFont = await doc.embedFont( sansFontBytes );

  const letterFont = await doc.embedFont( letterFontBytes, { subset: letterBackground.value !== 'nightstand' ? true : false } );
  
  const page = doc.getPages()[ 0 ];
    
  drawText( { doc, page, x: 576, y: 18, align: 'top right', text: `${ capitalize( firstName ) } ${ capitalize( lastName ) }`, font: sansFont, size: 20 } );

  drawText( { doc, page, x: 576, y: 46, align: 'top right', text: new Date().toLocaleString().split( ',' )[ 0 ], font: sansFont, size: 12 } );

  if ( letterBackground.value === 'table' )

    drawText( { doc, page, x: 115, y: 230, align: 'top left', text: letterContent.value || 'No response.', font: letterFont, size: 14, lineHeight: 22, maxWidth: 340 } );

  if ( letterBackground.value === 'typewriter' )

    drawText( { doc, page, x: 106, y: 212, align: 'top left', text: letterContent.value || 'No response.', font: letterFont, size: 10, lineHeight: 16, maxWidth: 350 } );

  if ( letterBackground.value === 'nightstand' )

    drawText( { doc, page, x: 155, y: 220, align: 'top left', text: letterContent.value || 'No response.', font: letterFont, size: 12, lineHeight: 18, maxWidth: 300 } );

  doc.setTitle( 'Activity Three' );
  
  doc.setSubject( 'Lewis Mountain' );
  
  doc.setCreator( 'Shenandoah National Park' );
    
  doc.setAuthor( 'National Park Service' );

  doc.setProducer( 'PDF-LIB (https://github.com/Hopding/pdf-lib)' );
  
  doc.setCreationDate( new Date() );
  
  doc.setModificationDate( new Date() );
  
  savePDF( `Lewis-Mountain-Activity-3-${ capitalize( firstName ) }-${ capitalize( lastName ) }`, doc );
  
}